import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectDepartmentName = (store: StoreSchema) => store.users.filters.departmentName
export const selectDepartmentNameQuery = (store: StoreSchema) => store.users.queryFilters.departmentName
